'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n\n  .button {\n    display: block;\n    width: calc(100% - 20px);\n    padding: 0.5rem;\n    margin-bottom: 0.5rem;\n    text-align: center;\n    text-decoration: none;\n    color: ', ';\n    background-color: ', ';\n    font-size: 1.5rem;\n    border: 5px solid #333;\n    border-radius: 0.5rem;\n\n    &:hover {\n      background-color: ', ';\n      color: ', ';\n    }\n  }\n\n  .button:last-child {\n    margin-bottom: 0;\n  }\n'], ['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n\n  .button {\n    display: block;\n    width: calc(100% - 20px);\n    padding: 0.5rem;\n    margin-bottom: 0.5rem;\n    text-align: center;\n    text-decoration: none;\n    color: ', ';\n    background-color: ', ';\n    font-size: 1.5rem;\n    border: 5px solid #333;\n    border-radius: 0.5rem;\n\n    &:hover {\n      background-color: ', ';\n      color: ', ';\n    }\n  }\n\n  .button:last-child {\n    margin-bottom: 0;\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Buttons = _styledComponents2.default.div(_templateObject, function (props) {
  return props.textColor || '#333';
}, function (props) {
  return props.backgroundColor || '#fff';
}, function (props) {
  return props.hoverBackgroundColor || '#777';
}, function (props) {
  return props.hoverTextColor || '#fff';
});

/** @class ButtonGroupContent
  * A component for rendering a collection of buttons
  * linking to internal or external content.
  * @param {Array} buttons - an array of button objects to display.
  * Button objects should have a text and url property.
  * @param {CSSColor} textColor - the color to use for button text (default gray).
  * @param {CSSColor} backgroundColor - the color to make the buttons (default white).
  * @param {CSSColor} hoverTextColor - the color to use for button text when the mouse hovers over the button (default white).
  * @param {CSSColor} hoverBackgroundColor - the color to use for the button when the mouse hovers over it (default gray).
  */

var ButtonGroupContent = function (_Component) {
  _inherits(ButtonGroupContent, _Component);

  function ButtonGroupContent() {
    _classCallCheck(this, ButtonGroupContent);

    return _possibleConstructorReturn(this, (ButtonGroupContent.__proto__ || Object.getPrototypeOf(ButtonGroupContent)).apply(this, arguments));
  }

  _createClass(ButtonGroupContent, [{
    key: 'render',

    /** @function
     * Renders the Title Content component.
     */
    value: function render() {
      var buttons = this.props.buttons.map(function (btn, index) {
        return _react2.default.createElement(
          'a',
          { className: 'button', href: btn.url, key: index, target: '_blank' },
          btn.text
        );
      });
      return _react2.default.createElement(
        Buttons,
        this.props,
        buttons
      );
    }
  }]);

  return ButtonGroupContent;
}(_react.Component);

exports.default = ButtonGroupContent;


ButtonGroupContent.propTypes = {
  buttons: _propTypes2.default.array.isRequired,
  textColor: _propTypes2.default.string,
  backgroundColor: _propTypes2.default.string,
  hoverTextColor: _propTypes2.default.string,
  hoverBackgroundColor: _propTypes2.default.string
};


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/content/button-group-content.js
// module id = 648
// module chunks = 0